(function () {
  function qsa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  function init(root) {
    if (!root || root.__amzp) return; root.__amzp = true;
    var dataEl = root.querySelector('[data-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var stage = root.querySelector('[data-stage]');
    var slides = stage ? qsa(stage, '.amz-pdp__slide') : [];
    var thumbs = qsa(root, '[data-thumb]');
    var dots = qsa(root, '.amz-pdp__dots span');

    function mark(i) {
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }
    function go(i) { if (!stage) return; stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' }); mark(i); }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { go(i); });
      t.addEventListener('mouseenter', function () { go(i); });
    });
    if (stage) {
      stage.addEventListener('scroll', function () { mark(Math.round(stage.scrollLeft / stage.clientWidth)); }, { passive: true });
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        slides.forEach(function (s) {
          var img = s.querySelector('img'); if (!img) return;
          s.addEventListener('mousemove', function (e) {
            var r = s.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
            s.classList.add('is-zoom');
          });
          s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
        });
      }
    }

    var desc = root.querySelector('[data-desc]');
    var more = root.querySelector('[data-desc-toggle]');
    if (desc && more && desc.scrollHeight > desc.clientHeight + 24) {
      desc.classList.add('is-long'); more.hidden = false;
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        more.textContent = open ? 'See less' : 'See more';
      });
    }

    var idInput = root.querySelector('[data-variant-id]');
    var opts = qsa(root, '[data-opt]');
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];

    function selected() { return opts.map(function (o) { var b = o.querySelector('.is-selected'); return b ? b.dataset.value : null; }); }
    function find(sel) { return variants.filter(function (v) { return v.options.every(function (x, i) { return x === sel[i]; }); })[0]; }

    function render(v) {
      current = v;
      var btns = qsa(root, '[data-add],[data-buy],[data-add-sticky]');
      var stock = root.querySelector('[data-stock]');
      if (!v) {
        stock.innerHTML = '<span class="is-out">This combination is unavailable</span>';
        btns.forEach(function (b) { b.disabled = true; });
        return;
      }
      qsa(root, '[data-price]').forEach(function (e) { e.textContent = v.price; });
      var off = root.querySelector('[data-off]'), mw = root.querySelector('[data-mrp-wrap]'), mrp = root.querySelector('[data-mrp]');
      if (v.cmp) { off.hidden = false; off.textContent = '-' + v.off + '%'; mw.hidden = false; mrp.textContent = v.cmp; }
      else { off.hidden = true; mw.hidden = true; }
      idInput.value = v.id;
      if (v.available) {
        stock.innerHTML = (v.qty !== null && v.qty > 0 && v.qty <= 5)
          ? '<span class="is-low">Only ' + v.qty + ' left in stock</span>'
          : '<span class="is-in">In stock</span>';
      } else {
        stock.innerHTML = '<span class="is-out">Currently unavailable</span>';
      }
      btns.forEach(function (b) { b.disabled = !v.available; });
      var add = root.querySelector('[data-add]'); if (add) add.textContent = v.available ? 'Add to Cart' : 'Sold out';
      if (v.media) {
        var idx = -1;
        slides.forEach(function (s, i) { if (s.dataset.mediaId === String(v.media)) idx = i; });
        if (idx > -1) go(idx);
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
    }

    function markUnavailable() {
      var sel = selected();
      opts.forEach(function (o, oi) {
        qsa(o, '.amz-pdp__val').forEach(function (b) {
          var s = sel.slice(); s[oi] = b.dataset.value;
          var v = find(s);
          b.classList.toggle('is-na', !v || !v.available);
        });
      });
    }

    opts.forEach(function (o) {
      qsa(o, '.amz-pdp__val').forEach(function (b) {
        b.addEventListener('click', function () {
          qsa(o, '.amz-pdp__val').forEach(function (x) { x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          var lab = o.querySelector('[data-opt-value]'); if (lab) lab.textContent = b.dataset.value;
          render(find(selected()));
          markUnavailable();
        });
      });
    });
    markUnavailable();

    var form = root.querySelector('[data-form]');
    var msg = root.querySelector('[data-msg]');
    function addToCart(checkout) {
      if (!current || !current.available) return Promise.resolve();
      var q = root.querySelector('[data-qty]');
      var qty = q ? Number(q.value) || 1 : 1;
      msg.className = 'amz-pdp__msg'; msg.textContent = 'Adding…';
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: qty }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
          if (checkout) { window.location.href = '/checkout'; return; }
          msg.className = 'amz-pdp__msg is-ok';
          msg.innerHTML = '&#10003; Added to cart &middot; <a href="/cart">View cart</a> &middot; <a href="/checkout">Checkout</a>';
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
            if (window.amzUpdateCartCount) window.amzUpdateCartCount(c.item_count);
          });
        }).catch(function (e) { msg.className = 'amz-pdp__msg is-err'; msg.textContent = e.message; });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(false); });
    var buy = root.querySelector('[data-buy]');
    if (buy) buy.addEventListener('click', function () { addToCart(true); });
    var sticky = root.querySelector('[data-sticky]');
    var sbtn = root.querySelector('[data-add-sticky]');
    if (sbtn) sbtn.addEventListener('click', function () {
      addToCart(false).then(function () { if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    });
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(form);
    }
  }

  function recos(el) {
    if (el.__amzr || !el.dataset.url) return; el.__amzr = true;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (t) {
      var d = document.createElement('div'); d.innerHTML = t;
      var n = d.querySelector('[data-amz-recos]');
      if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; if (window.amzInit) window.amzInit(el); }
    }).catch(function () {});
  }

  function all() {
    document.querySelectorAll('[data-amz-pdp]').forEach(init);
    document.querySelectorAll('[data-amz-recos]').forEach(recos);
  }
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();